import { PropsWithChildren } from 'react';

import { usePrefetchShops } from '@frontend/data/use-shop-query';

export const Prefetch = (props: PropsWithChildren) => {
  usePrefetchShops();

  return <>{props.children}</>;
};
